import React from "react";
import { Package, WashingMachine, HandHeart } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Package,
    title: "Drop Off (or We Pick Up)",
    body:
      "Bring a load to our Hamilton location, or arrange a free pickup through a partner shelter or school. We accept clothes, bedding, towels — anything that needs to be clean.",
  },
  {
    n: "02",
    icon: WashingMachine,
    title: "We Wash, Dry & Fold",
    body:
      "Our volunteers handle every load with care — hypoallergenic detergent, separated colors, and a fold that respects the family. Same-day turnaround whenever possible.",
  },
  {
    n: "03",
    icon: HandHeart,
    title: "Returned, With Dignity",
    body:
      "Clothes go back in clean, branded bags — never trash bags. Families receive them with no questions and no paperwork. Just clean clothes, ready for tomorrow.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-section"
      className="py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#D85C41]">
              How It Works
            </span>
            <h2 className="mt-3 font-display text-4xl md:text-5xl font-bold leading-[1.05]">
              Three steps. Zero cost. Zero shame.
            </h2>
          </div>
          <p className="text-base md:text-lg text-[#57534E] max-w-md">
            We built this program around one rule: a family asking for help
            should never feel like they did something wrong.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {STEPS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`step-${s.n}`}
                className="relative rounded-3xl bg-[#F9F7F4] border border-[#E7E2DA] p-8 md:p-10 hover:border-[#D85C41] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[#D85C41] text-white">
                    <Icon className="h-6 w-6" strokeWidth={2} />
                  </div>
                  <span className="font-display text-5xl font-extrabold text-[#EAE5DF]">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold text-[#1C1917]">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#57534E] leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
